import axiosApi from '../../kits/axiosApi';

// initial state
const state = {
};

// getters
const getters = {
};

// actions
const actions = {
    exportReserveData({ rootState }, params) {
        let aj_host = rootState.aj_host;

        return new Promise((resolve, reject) => {
            axiosApi({
                method: 'get',
                url: aj_host + '/weapp/master/reserve/export',
                params: params,
                responseType: 'blob'
            })
                .then((res) => {
                    resolve(res.data)
                })
                .catch((err) => {
                    reject(err)
                })
        });
    },
};

// mutations
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
